import { Outlet } from "react-router-dom";
import { FullHeightLayout } from "./AuthLayout.styles";
import { useEffect } from "react";
import httpClient from "../../../api/httpClient";
import { ROUTES } from "../../../constant/routes";
import LogoImage from "../../../assets/images/logo.png";

const AuthLayout = () => {
  const acesstoken = httpClient.getAccessToken();

  useEffect(() => {
    if (acesstoken) window.location.href = ROUTES.DASHBOARD;
  }, [acesstoken]);

  return (
    <>
      {!acesstoken && (
        <FullHeightLayout>
          <div
            className={`card-div ${window.location.pathname === ROUTES.SIGNUP ? "signup-card" : ""} `}
          >
            <div className="auth-left">
              <div className="left-top">
                <div className="logo-wrap">
                  <img src={LogoImage} alt="Kelu Logo" />
                  <div className="brand-name">
                    Kelu
                    <span>Workspace</span>
                  </div>
                </div>

                <h1 className="sub-title">Your Customer &amp; Workspace</h1>
                <div className="accent-line" />
                <p className="left-desc">
                  Messaging, collaboration, meetings, tasks, documents and AI 
                  all in one place.
                </p>
              </div>

              <div className="left-bottom">
                <div className="feature-pills">
                  <div className="pill">
                    <div className="pill-icon">💬</div>
                    <div className="pill-text">
                      Conversations
                      <span>Message customers in one secure place</span>
                    </div>
                  </div>
                  <div className="pill">
                    <div className="pill-icon">📋</div>
                    <div className="pill-text">
                      Workspace
                      <span>Manage teams, branches and cases</span>
                    </div>
                  </div>
                  <div className="pill">
                    <div className="pill-icon">🤖</div>
                    <div className="pill-text">
                      AI Agents
                      <span>
                        Automate work with AI that knows your business
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <Outlet />
          </div>
        </FullHeightLayout>
      )}
    </>
  );
};

export default AuthLayout;
